var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2.375","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }